import React, { createContext, useEffect, useState } from 'react';

interface PrintContextType {
  printImgWidth: number;
  printImgHeight: number;
  printDialogOpen: boolean;
  setPrintDialogOpen: (v: boolean) => void;
}

export const PrintContext = createContext<PrintContextType>({
  printImgWidth: 284,
  printImgHeight: 330,
  printDialogOpen: false,
  setPrintDialogOpen: (v) => {},
});

export const PrintProvider: React.FC<{
  children?: React.ReactNode;
}> = ({ children }) => {
  const [printDialogOpen, setPrintDialogOpen] = useState(false);
  // These sizes are hard coded in The legTwoVisualStep.scss file.  If they change there, they must change here.
  const printImgWidth = 284;
  const printImgHeight = 330;

  const handleBeforePrint = () => {
    setPrintDialogOpen(true);
  };

  const handleAfterPrint = () => {
    setPrintDialogOpen(false);
  };

  useEffect(() => {
    window.addEventListener('beforeprint', handleBeforePrint);
    window.addEventListener('afterprint', handleAfterPrint);
    window.addEventListener('focus', handleAfterPrint);

    return () => {
      window.removeEventListener('beforeprint', handleBeforePrint);
      window.removeEventListener('afterprint', handleAfterPrint);
      window.removeEventListener('focus', handleAfterPrint);
    };
  }, []);

  return (
    <PrintContext.Provider
      value={{
        printImgWidth,
        printImgHeight,
        printDialogOpen,
        setPrintDialogOpen,
      }}
    >
      {children}
    </PrintContext.Provider>
  );
};
